var exports = {
  "LP": "task-list-item__j0Lg7R",
  "Mf": "numbered-task-list__VUaQ2I",
  "Oi": "numbered-task-list-nested__Ta416m",
  "AE": "unordered-task-list__qmb8rI",
  "_3": "unordered-task-list-nested__dH802n",
  "ru": "bullet-task-item__jFf7DR",
  "Do": "numbered-task-item__mE1qfi",
  "c": "nested-overlay-list__UaE-UV",
  "dU": "overlay-task-list-child__RfdM3M",
};

module.exports = exports;
